var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgExistingEmail(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 223,
    height: 161,
    viewBox: "0 0 223 161",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 38.0742,
    y: 139.518,
    width: 80.5,
    height: 17.5,
    rx: 8.75,
    transform: "rotate(-15 38.0742 139.518)",
    fill: "#D95B00",
    fillOpacity: 0.1
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 20.7031,
    y: 128.773,
    width: 80.5,
    height: 11.375,
    rx: 5.6875,
    transform: "rotate(-15 20.7031 128.773)",
    fill: "#D95B00",
    fillOpacity: 0.1
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 30.375,
    y: 110.782,
    width: 80.5,
    height: 11.375,
    rx: 5.6875,
    transform: "rotate(-15 30.375 110.782)",
    fill: "#D95B00",
    fillOpacity: 0.1
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 147.191,
    y: 100.232,
    width: 70.8102,
    height: 15.3935,
    rx: 7.69676,
    transform: "rotate(-15 147.191 100.232)",
    fill: "#D95B00",
    fillOpacity: 0.1
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 131.91,
    y: 90.7811,
    width: 70.8102,
    height: 10.0058,
    rx: 5.00289,
    transform: "rotate(-15 131.91 90.7811)",
    fill: "#D95B00",
    fillOpacity: 0.1
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 140.418,
    y: 74.9546,
    width: 70.8102,
    height: 10.0058,
    rx: 5.00289,
    transform: "rotate(-15 140.418 74.9546)",
    fill: "#D95B00",
    fillOpacity: 0.1
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 41.1602,
    y: 80.7161,
    width: 64.4,
    height: 14,
    rx: 7,
    transform: "rotate(-15 41.1602 80.7161)",
    fill: "#D95B00",
    fillOpacity: 0.1
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 27.2617,
    y: 72.12,
    width: 64.4,
    height: 9.1,
    rx: 4.55,
    transform: "rotate(-15 27.2617 72.12)",
    fill: "#D95B00",
    fillOpacity: 0.1
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 57.7278,
    width: 64.4,
    height: 9.1,
    rx: 4.55,
    transform: "rotate(-15 35 57.7278)",
    fill: "#D95B00",
    fillOpacity: 0.1
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 119.844,
    y: 44.4141,
    width: 64.4,
    height: 14,
    rx: 7,
    transform: "rotate(-15 119.844 44.4141)",
    fill: "#D95B00",
    fillOpacity: 0.1
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 105.949,
    y: 35.8175,
    width: 64.4,
    height: 9.1,
    rx: 4.55,
    transform: "rotate(-15 105.949 35.8175)",
    fill: "#D95B00",
    fillOpacity: 0.1
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 113.684,
    y: 21.4249,
    width: 64.4,
    height: 9.1,
    rx: 4.55,
    transform: "rotate(-15 113.684 21.4249)",
    fill: "#D95B00",
    fillOpacity: 0.1
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 48.6094,
    y: 9,
    width: 137,
    height: 136,
    rx: 68,
    fill: "#FFEADB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M114.594 149.5C100.255 149.5 86.2375 145.248 74.3149 137.282C62.3923 129.315 53.0998 117.992 47.6125 104.745C42.1251 91.4969 40.6894 76.9196 43.4868 62.856C46.2842 48.7923 53.1892 35.8741 63.3285 25.7348C73.4678 15.5955 86.3861 8.6905 100.45 5.89307C114.513 3.09564 129.091 4.53138 142.338 10.0187C155.586 15.5061 166.909 24.7986 174.875 36.7212C182.842 48.6437 187.094 62.6609 187.094 77",
    stroke: "#FF8C39",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M186.011 89.4848C183.38 104.533 176.063 118.366 165.104 129.009C154.145 139.652 140.104 146.562 124.985 148.751",
    stroke: "#FF8C39",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M137.594 77V64.5H142.594V79.5H137.594M137.594 89.5H142.594V84.5H137.594M112.594 79.5C119.269 79.5 132.594 82.85 132.594 89.5V97H92.5938V89.5C92.5938 82.85 105.919 79.5 112.594 79.5ZM112.594 57C115.246 57 117.789 58.0536 119.665 59.9289C121.54 61.8043 122.594 64.3478 122.594 67C122.594 69.6522 121.54 72.1957 119.665 74.0711C117.789 75.9464 115.246 77 112.594 77C109.942 77 107.398 75.9464 105.523 74.0711C103.647 72.1957 102.594 69.6522 102.594 67C102.594 64.3478 103.647 61.8043 105.523 59.9289C107.398 58.0536 109.942 57 112.594 57ZM112.594 84.25C105.169 84.25 97.3438 87.9 97.3438 89.5V92.25H127.844V89.5C127.844 87.9 120.019 84.25 112.594 84.25ZM112.594 61.75C111.201 61.75 109.866 62.3031 108.881 63.2877C107.897 64.2723 107.344 65.6076 107.344 67C107.344 68.3924 107.897 69.7277 108.881 70.7123C109.866 71.6969 111.201 72.25 112.594 72.25C113.986 72.25 115.321 71.6969 116.306 70.7123C117.291 69.7277 117.844 68.3924 117.844 67C117.844 65.6076 117.291 64.2723 116.306 63.2877C115.321 62.3031 113.986 61.75 112.594 61.75Z",
    fill: "#FF8C39"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExistingEmail);
export default __webpack_public_path__ + "static/media/existingEmail.37a0578ca0c783a82c59425f91ec5b84.svg";
export { ForwardRef as ReactComponent };